import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getVenders = (props) => {
  return safeAwait(
    lsGet(`/venders?${stringify({ ...props, isFilterListVisible: true })}`)
  )
}
